'use client'

import { DEFAULT_BANNER_URL } from '@/constants/stackup'
import { Event } from '@/types'
import Image from 'next/image'
import { usePathname } from 'next/navigation'
import { ReactNode } from 'react'

interface LayoutProviderProp {
  children: ReactNode
  event?: Event
}

const LayoutProvider = ({ children, event }: LayoutProviderProp) => {
  const pathname = usePathname()
  const isRegistrationRoute = pathname.includes('/registration')

  return (
    <>
      {!isRegistrationRoute ? (
        <div className="m-auto w-full bg-white">
          <div className="relative max-w-[1368px] m-auto">
            <Image
              priority
              src={event?.banner_url || DEFAULT_BANNER_URL}
              alt="Event Banner"
              width={0}
              height={0}
              sizes="100vw"
              className="object-cover w-full h-24 sm:h-36 lg:h-52 xl:h-64 2xl:h-72"
            />
          </div>
        </div>
      ) : null}
      {children}
    </>
  )
}

export default LayoutProvider
